<template>
  <Toast />
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button :label="message.rejectLabel" outlined @click="rejectCallback" class="w-32"></Button>
          <Button :label="message.acceptLabel" @click="acceptCallback" class="w-32"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <IndexView />
  <ViewContainer>
    <section class="p-6">
      <BackButton class="mb-5" to_url="/inbound-items-form" />
      <PageTitle title="Refill Stok" />
      <div
        class="bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg shadow-light-100 dark:shadow-dark-500 dark:text-dark-500">
        <InputRadio v-model="formType" id="form-type" name="form-type" label="Tipe Refill Stok"
          :options="optionFormType" :valid="validation.form_type.valid" :error-message="validation.form_type.message" />
        <InputSelect v-if="formType == 'purchase'" v-model="inboundItemsForm.inbound_from" id="inbound-from" name="inbound-from" label="Asal"
          :options="optionInboundFrom" :valid="validation.inbound_from.valid" :error-message="validation.inbound_from.message" />
        <InputTextCustom v-if="formType == 'misc'" v-model="inboundItemsForm.inbound_from" id="inbound-from" name="inbound-from" label="Dari"
          type="text" div_class="w-full" @input="inboundItemsForm.inbound_from = $event.target.value" />

        <div class="flex justify-center mt-5">
          <Button type="submit" label="Buat Draft" :loading="loading" @click="submitInboundItemsForm" />
        </div>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
import IndexView from '@/views/IndexView.vue';
import PageTitle from '@/components/PageTitle.vue';
import BackButton from '@/components/buttons/BackButton.vue';
import InputRadio from '@/components/form/InputRadio.vue';
// import TextArea from '@/components/form/TextArea.vue';
import { mapActions, mapGetters } from 'vuex';
import { Button, ConfirmDialog, Toast } from "primevue";
import ViewContainer from '@/components/ViewContainer.vue';
import InputSelect from '@/components/form/InputSelect.vue';
import InputTextCustom from '@/components/form/InputTextCustom.vue';

export default {
  name: "AddEditCustomer",
  props: ['id'],
  components: {
    IndexView, PageTitle, BackButton, InputRadio, Button, ConfirmDialog, Toast, ViewContainer, InputSelect, InputTextCustom
  },
  data() {
    return {
      loading: false,
      formType: null,
      isEdit: false,
      inboundItemsForm: {
        form_type: null,
        inbound_from: null,
        notes: null,
      },
      validation: {
        form_type: {
          valid: true,
          message: ''
        },
        inbound_from: {
          valid: true,
          message: ''
        },
      },
    }
  },
  computed: {
    ...mapGetters('outlets', ['allOutlets']),
    optionFormType() {
      return [
        { value: 'purchase', label: 'Refill Stok' },
        { value: 'misc', label: 'Lain-lain' },
      ];
    },
    optionInboundFrom() {
      return [
        { label: 'Pabrik', value: 'pabrik' },
        ...this.allOutlets.map(outlet => ({
          label: outlet.name,
          value: outlet.name
        })),
      ];
    },
  },
  methods: {
    ...mapActions('inbound_items_forms', ['createInboundItemsForm']),
    submitInboundItemsForm() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin membuat draft barang masuk?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postInboundItemsForm();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan draft barang masuk', life: 3000 });
        }
      });
    },
    async postInboundItemsForm() {
      try {
        this.loading = true;
        const inboundItemsFormData = {
          form_type: this.formType,
          inbound_from: this.inboundItemsForm.inbound_from,
          notes: this.inboundItemsForm.notes,
          status: "pending",
        };

        const { data } = await this.createInboundItemsForm(inboundItemsFormData);

        // if (this.isEdit && this.inboundItemsForm) {
        //   inboundItemsFormData.id = this.inboundItemsForm.id;
        //   await this.updateInboundItemsForm(inboundItemsFormData);
        // }
        // else {
        //   await this.createInboundItemsForm(inboundItemsFormData);
        // }

        await this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Draft Stock Opname telah dibuat', life: 5000 });
        this.$router.push(`/inbound-items-form/edit/${data.id}`);
      }
      catch (error) {
        console.error('Failed to save inbound items form:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
      finally {
        this.loading = false;
      }
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    }
  },
  async created() {
    await this.$store.dispatch('outlets/fetchOutlets');
  }
}
</script>